// UploadModalMediaThumbnail.jsx
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import StatefulImage from '../component/StatefulImage.jsx';

import PlayIconSource from '../../img/ic_grid_video.svg';
import MultipleIconSource from '../../img/btn_post_24.svg';

export const UploadModalMediaThumbnail = ({
  posterObjectUrl = null,
  assetObjectUrl = null,
  messageThumbnail = null,
  contentType = null,
  isMultipleAssets = false,
  shouldShowPostTypeIcon = false,
}) => {
  const isVideo = /video\//i.test(contentType);
  return (
    <StyledUploadModalMediaThumbnail>
      {isVideo ? (
        posterObjectUrl ? (
          <StatefulImage>
            <ImagePreview data-key="target" src={posterObjectUrl} />
          </StatefulImage>
        ) : assetObjectUrl ? (
          <VideoPreview
            src={assetObjectUrl}
            playsInline
            muted
            onLoadedMetadata={({ target }) => target.play()}
            onPlay={({ target }) => target.pause()}
          />
        ) : messageThumbnail ? (
          <StatefulImage>
            <ImagePreview data-key="target" src={messageThumbnail} />
          </StatefulImage>
        ) : null
      ) : (
        <StatefulImage>
          <ImagePreview
            data-key="target"
            src={assetObjectUrl || messageThumbnail}
          />
        </StatefulImage>
      )}
      {shouldShowPostTypeIcon ? (
        isMultipleAssets ? (
          <ThumbnailSourceIcon src={MultipleIconSource} aria-hidden />
        ) : isVideo ? (
          <ThumbnailSourceIcon src={PlayIconSource} aria-hidden />
        ) : null
      ) : null}
    </StyledUploadModalMediaThumbnail>
  );
};

UploadModalMediaThumbnail.propTypes = {
  assetObjectUrl: PropTypes.string,
  posterObjectUrl: PropTypes.string,
  messageThumbnail: PropTypes.string,
  contentType: PropTypes.string,
  isMultipleAssets: PropTypes.bool,
  shouldShowPostTypeIcon: PropTypes.bool,
};

const StyledUploadModalMediaThumbnail = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
`;

const VideoPreview = styled.video`
  width: 100%;
  height: 100%;
  object-fit: cover;
`;

const ImagePreview = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
`;

const ThumbnailSourceIcon = styled.img`
  position: absolute;
  top: 4px;
  right: 4px;
  width: 14px;
  height: 14px;
  object-fit: contain;
`;

export default UploadModalMediaThumbnail;
